import { AdminShell } from '@/features/admin/components/admin-shell.js';
import { GrantForm } from '@/features/admin/components/grants/grant-form.js';
import { GrantsList } from '@/features/admin/components/grants/grants-list.js';
import { GrantsMatrix } from '@/features/admin/components/grants/grants-matrix.js';
import { useAuth } from '@/lib/auth/use-auth.js';
import { tokens } from '@/lib/tokens.js';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/_admin/grants')({
  component: GrantsPage,
});

type View = 'list' | 'create' | 'matrix';

function GrantsPage() {
  const { user } = useAuth();
  const [view, setView] = useState<View>('list');
  const tenantId = user?.tenant ?? '';

  return (
    <AdminShell currentPath="/grants">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}
        >
          <h1
            style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: tokens.colors.textDark,
              margin: 0,
            }}
          >
            Grants
          </h1>
          {view !== 'list' && (
            <button
              type="button"
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: tokens.colors.primary,
                cursor: 'pointer',
                fontSize: '0.875rem',
                padding: 0,
              }}
              onClick={() => setView('list')}
              aria-label="Back to list"
            >
              ← Back
            </button>
          )}
        </div>

        {view === 'list' && (
          <GrantsList
            tenantId={tenantId}
            onGrantClick={() => setView('create')}
            onMatrixClick={() => setView('matrix')}
          />
        )}

        {view === 'create' && (
          <GrantForm
            tenantId={tenantId}
            onSuccess={() => setView('list')}
            onCancel={() => setView('list')}
          />
        )}

        {view === 'matrix' && <GrantsMatrix tenantId={tenantId} onClose={() => setView('list')} />}
      </div>
    </AdminShell>
  );
}
